<template>
    <div class="report-result-content-sub-info">
        <span class="text">于{{ UTILS.getChineseTimeYMDHmByTimeStamp(lastTime) }}生成报告</span>
        <button class="report-rbul-button report-rbul-button-4" :class="{'gray' : parseInt(UTILS.checkTimeDiffMinuteToNow(lastTime)/60) < 24}" @click="clickRePay">重新生成</button>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
export default {
    name: 'ReportRePayBar',
    props: {
        lastTime: {
            type: Number,
            default() {
                return 0
            }
        },
        productData: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            UTILS: UTILS
        }
    },
    mounted() {
        
    },
    methods: {
        clickRePay() {
            if(parseInt(UTILS.checkTimeDiffMinuteToNow(this.lastTime)/60) < 24) {
                this.$toast({
                    message: '当前已经是最新数据，24小时之后才可重新生成，终身会员不限次重生',
                    className: 'van-toast--width-80',
                });
                return;
            }
            console.log('clickRePay----', this.productData.pid);
            switch(this.productData.pid) {
                case 'pay_31100': //天赋
                    MIX.trackButtonClicked('regenerate_matrix');
                    break;
                case 'pay_10001': //12个月
                    MIX.trackButtonClicked('regenerate_12_month');
                    break;
                case 'pay_10003': //5年
                    MIX.trackButtonClicked('regenerate_5_year');
                    break;
                case 'pay_10004': //总运程
                    MIX.trackButtonClicked('regenerate_all_life');
                    break;
                default:
                    break;
            }
            this.$store.state.report.showReportRepayPopup = true;
            this.$store.state.report.curReportRepayProductData = Object.assign({}, this.productData);
        },
    }
}
</script>